import dayjs from 'dayjs'

const FORMATTERS = {
  Day: ({ hour }) => `${hour}:00`,
  Week: ({ year, chartMonth, chartDay }) => `${dayjs(`${year}-${chartMonth + 1}`).format('MMM')} ${chartDay}`,
  Month: ({ year, chartMonth, chartDay }) => `${year}-${chartMonth + 1}-${chartDay}`,
  Year: ({ year, chartMonth }) => `${year}-${chartMonth + 1}`,
}
export const getChartDate = (period, contract) => FORMATTERS[period]?.(contract)
